import {menuToggle} from './components/menu';
import {modal} from './components/modal';
import {contactForm} from './components/contact-form';
import {galleryFade} from './components/gallery-fade';

menuToggle();
modal('js-gallery-item');
contactForm('contact-form', 'contact-form-submit');
galleryFade();
